/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import {
  Card, CardContent, Typography, Button, useMediaQuery,
} from '@material-ui/core';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Alert } from '@material-ui/lab';

const TextCard = ({ darkMode }) => {
  const isMobile = useMediaQuery('(max-width: 900px)');
  const [expand, setExpand] = useState(null);

  const readMore = () => {
    setExpand(true);
  };

  /**
   * Truncate the string length after 80 chars.
   * @param {String} text
   */
  const limitText = (text) => {
    if (text.length > 60) {
      const newText = `${text.substring(0, 60)} ...`;
      return newText;
    }
    return text;
  };

  return !isMobile || expand ? (
    <Card className="card-ui" style={{ margin: '2em 0 2em 0' }}>
      <CardContent>
        <Typography component="p" variant="h5" style={{ textAlign: 'center', marginBottom: '20px' }}>
          Learning Links
          {' '}
          - linking you to a world of English learning resources.
        </Typography>
        <Typography component="p" variant="body1" style={{ textAlign: 'center' }}>
          Links organized by theme will help you develop and practice your English
          in the form of quizzes, exercises, podcasts, videos, articles and apps.
        </Typography>
        <Alert severity="error" style={{ marginTop: '30px' }}>
          {`${'IMPORTANT: L\'onglet "Learning links" vous permet d\'accéder à des ressources supplémentaires.'}`}
          {`${'Il ne prend pas en compte le temps de connexion et n\'a pas d\'impact sur vos résultats.'}`}
        </Alert>
      </CardContent>
    </Card>
  ) : (
    <Card className="card-ui" style={{ margin: '2em 0 2em 0' }}>
      <CardContent>
        <Typography component="p" variant="body1">
          {limitText('Learning Links is an additional resource that will give you access to global English learning. Different themes are available in order to perfect your understanding, practice and general knowledge in the form of quizzes, exercises, podcasts, videos, articles or even mobile applications.') }
        </Typography>
        <Button aria-label="Lire plus de contenu sur Learning Links" onClick={readMore}>
          <Typography component="p" variant="body1" style={{ textDecoration: 'underline', paddingTop: '1em' }}>
            Read more
          </Typography>
        </Button>
      </CardContent>
    </Card>
  );
};

TextCard.propTypes = {
  darkMode: PropTypes.bool.isRequired,
};

function mapState(state) {
  const { darkMode } = state.ui;

  return {
    darkMode,
  };
}

export default connect(mapState)(TextCard);
